import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const H1 = styled.h1`
  font-weight: 900;

  &,
  * {
    font-size: 44px;
    line-height: 56px;
  }

  ${media.tablet`
    &, * {
      font-size: 26px;
      line-height: 32px;
    }
  `}
`

export default H1
